const lowercaseNumericRegex = /^[a-z0-9 ]+$/;

export const checkUppercaseAndSpecialCharacters = (value: string) => {
  return value !== '' && !lowercaseNumericRegex.test(value);
};
